export default __webpack_public_path__ + "static/media/userimage.5afe7a3d.svg";